// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"d5246d5c","338":"9db8ec85","432":"b1572c9d","576":"f913b594"}[chunkId] + ".chunk.css";
};